/**
 * Vuex Store
 *
 * The {@link http://vuex.vuejs.org/en/index.html | store } of the application.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import quiz from './modules/quiz';
import question from './modules/question';
import course from './modules/course';
import lesson from './modules/lesson';
import badge from './modules/badge';
import user from './modules/user';
import school from './modules/school';
import image from './modules/image';
import sitePlace from './modules/sitePlace';
import file from './modules/file';
import courseMap from './modules/courseMap';
import courseStatus from './modules/courseStatus';
import lessonStatus from './modules/lessonStatus';
import topicStatus from './modules/topicStatus';
import topic from './modules/topic';
import ad from './modules/ad';
import news from './modules/news';
import mail from './modules/mail';
import country from './modules/country';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    /**
     * Assign the modules to the store.
     */
    modules: {
        auth,
        quiz,
        question,
        course,
        lesson,
        badge,
        user,
        school,
        image,
        file,
        sitePlace,
        courseStatus,
        lessonStatus,
        topicStatus,
        topic,
        ad,
        news,
        mail,
        country,
        courseMap,
    },

    /**
     * If strict mode should be enabled.
     */
    strict: false,
});



// WEBPACK FOOTER //
// ./src/store/index.js